export const MOBILE_BREAKPOINT = 768;
export const SPLASH_DURATION = 3000;
export const Defualt_page_count = 0;